import settings from '@/constants/constants';
import { usePreOnboardingContext } from '@/hooks/escript/usePreOnboardingContext';
import { ESCRIPT_ONBOARDING_ROUTE, LOGIN_ROUTE, UMEDS_MARKETING } from '@/routes/route-paths';
import { ContainedButtonInverted, OutlinedButtonInverted } from '@/theme/buttons';
import { Box, IconButton, Link } from '@montugroup/design-system';
import { styled } from '@mui/material';
import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  StyledCloseIcon,
  StyledMenuDrawer,
  StyledMenuIcon,
  StyledMenuIconContainer,
  StyledNavLinkContainer,
  StyledNavToolbar,
} from '../Onboarding.styles';
import { StyledUmedsLogo } from '../OnboardingHeader/OnboardingHeader';

const FaqLink = styled(Link)(({ theme }) => ({
  margin: `${theme.spacing(1)} 0`,
  fontWeight: 600,
  textDecoration: 'none',
  alignSelf: 'center',
  color: theme.palette.common.white,
}));

export function OnboardingMenuMobile() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { resetOnboardingState } = usePreOnboardingContext();

  const toggleMenu = () => {
    setMenuOpen((prevState) => !prevState);
  };

  const onMobilePrescriptionNavLinkClick = () => {
    toggleMenu();
    resetOnboardingState();
  };

  return (
    <Box>
      <StyledMenuIconContainer>
        <IconButton size="small" aria-haspopup="true" aria-label="menu" onClick={toggleMenu}>
          <StyledMenuIcon />
        </IconButton>
      </StyledMenuIconContainer>

      <StyledMenuDrawer anchor="top" open={menuOpen} onClose={toggleMenu} onOpen={toggleMenu}>
        <StyledNavToolbar>
          <RouterLink to={UMEDS_MARKETING.HOME} onClick={toggleMenu}>
            <StyledUmedsLogo fillColor={(theme) => theme.palette.common.white} />
          </RouterLink>

          <StyledMenuIconContainer>
            <IconButton onClick={toggleMenu}>
              <StyledCloseIcon />
            </IconButton>
          </StyledMenuIconContainer>
        </StyledNavToolbar>

        <StyledNavLinkContainer>
          <OutlinedButtonInverted
            component={RouterLink}
            to={LOGIN_ROUTE}
            variant="outlined"
            color="primary"
            size="large"
            data-tracking-id="escript_onboarding_header_login_mobile"
          >
            Sign in
          </OutlinedButtonInverted>

          <ContainedButtonInverted
            to={ESCRIPT_ONBOARDING_ROUTE}
            size="large"
            variant="contained"
            data-tracking-id="onboarding_header_prescription_mobile"
            onClick={onMobilePrescriptionNavLinkClick}
          >
            Submit Prescription
          </ContainedButtonInverted>

          <FaqLink href={`${settings.marketing.site.url}/faq`} rel="noopener noreferrer" target="_blank">
            FAQs
          </FaqLink>
        </StyledNavLinkContainer>
      </StyledMenuDrawer>
    </Box>
  );
}
